export function getdata(){
	var obj = {
			headDataI:[
				{
					title:"操作",
					prop:"cz",
					width:"130px",
					custom:true,
				},
				{
					title: "开票方纳税人识别号",
					prop: "whsy_1_x_1",
					width:"100px",
					custom:true,
				},
				{
					title: "开票方单位名称",
					prop: "whsy_1_x_2",
					width:"180px",
					custom:true,
				},
				{
					title: "服务项目名称",
					prop: "whsy_1_x_3",
					custom:true,
					width:"180px",
				},
				{
					title: "凭证种类",
					prop: "whsy_1_x_4",
					custom:true,
					width:"180px",
				},
				{
					title: "凭证号码",
					prop: "whsy_1_x_5",
					custom:true,
					width:"180px",
				},{
					title: "金额",
					prop: "whsy_1_x_6",
					custom:true,
					width:"180px",
				},
			],
			tableDataI:[
				{
					disabledwhsy_1_x_1:false,
					disabledwhsy_1_x_2:false,
					disabledwhsy_1_x_3:false,
					disabledwhsy_1_x_4:false,
					disabledwhsy_1_x_5:false,
					disabledwhsy_1_x_6:false,
					whsy_1_x_1:{
						cellCode:"whsy_1_x_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					whsy_1_x_2:{
						cellCode:"whsy_1_x_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					whsy_1_x_3:{
						cellCode:"whsy_1_x_3",
						cellType:"1",
						cellVal:"240040043.08"
					},
					whsy_1_x_4:{
						cellCode:"whsy_1_x_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
					whsy_1_x_5:{
						cellCode:"whsy_1_x_5",
						cellType:"1",
						cellVal:"240040043.08"
					},
					whsy_1_x_6:{
						cellCode:"whsy_1_x_6",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					disabledwhsy_1_x_1:false,
					disabledwhsy_1_x_2:false,
					disabledwhsy_1_x_3:false,
					disabledwhsy_1_x_4:false,
					disabledwhsy_1_x_5:false,
					disabledwhsy_1_x_6:false,
					whsy_1_x_1:{
						cellCode:"whsy_1_x_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					whsy_1_x_2:{
						cellCode:"whsy_1_x_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					whsy_1_x_3:{
						cellCode:"whsy_1_x_3",
						cellType:"1",
						cellVal:"240040043.08"
					},
					whsy_1_x_4:{
						cellCode:"whsy_1_x_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
					whsy_1_x_5:{
						cellCode:"whsy_1_x_5",
						cellType:"1",
						cellVal:"240040043.08"
					},
					whsy_1_x_6:{
						cellCode:"whsy_1_x_6",
						cellType:"1",
						cellVal:"240040043.08"
					},
				}
			],
	}
	return obj
}
